<template>
  <section id="button" class="doc-component">
    <h2 class="title">Botões</h2>
    <p>O componente Botão possui interações de designer ao receber os eventos hover/focus e click/touch, ou seja, possui animações previamente pensadas, afim de indicar o comportamento realizado.</p>
    <p>Existem 2 componentes de botão com suas características já pré-definidas</p>
    <div class="highlight-grid">
      <p>
        <round-button>round-button</round-button>
        <simple-button>simple-button</simple-button>
      </p>
      <code>
        &lt;round-button&gt;round-button&lt;/round-button&gt;
      </code>
      <br>
      <code>
        &lt;simple-button&gt;simple-button&lt;/simple-button&gt;
      </code>
    </div>

    <p>O componente por default renderiza <code>&lt;button type="button"&gt;</code>, podendo ser alterado direto no componente</p>
    <p>Caso queira um link <code>&lt;a&gt;</code>, basta adicionar o atributo <code>href</code> no componente, conforme abaixo:</p>
    <div class="highlight-grid">
      <round-button type="submit">button</round-button>
      <round-button type="submit">submit</round-button>
      <simple-button type="reset">reset</simple-button>
      <simple-button href="http://www.moip.com.br">um link</simple-button>
      <round-button href="http://www.moip.com.br">outro link</round-button>
    </div>

    <h2 class="title">Cores</h2>
    <p>Adicione a <b>classe referente a cor</b>, lembrando que até o momento possuímos somente as cores abaixo listadas</p>
    <p>A cor default é o azul, podendo variar entre as cores <code>pink, purple, green, light-blue</code></p>
    <div class="highlight-grid">
      <p>
        <round-button href="http://www.moip.com.br" target="_blank">default</round-button>
        <round-button class="pink" type="submit">pink</round-button>
        <round-button class="purple" type="submit">purple</round-button>
        <round-button class="green" type="submit">green</round-button>
        <round-button class="light-blue" type="submit">light-blue</round-button>
      </p>
      <code>
        &lt;round-button class="pink"&gt;pink&lt;/round-button&gt;
      </code>
      <p>
        <simple-button >default</simple-button>
        <simple-button class="pink" icon="edit">pink</simple-button>
        <simple-button class="purple" icon="edit">purple</simple-button>
        <simple-button class="green">green</simple-button>
        <simple-button class="light-blue">light-blue</simple-button>
      </p>
      <code>
        &lt;simple-button class="pink"&gt;pink&lt;/simple-button&gt;
      </code>
    </div>

    <h2 class="title">Ocupando 100%</h2>
    <p>Adicione a classe "full" para que o botão ocupe 100% do seu container</p>
    <div class="highlight-grid">
      <round-button class="full">round-button 100%</round-button>
      <code>&lt;round-button class="full"&gt;&lt;/round-button&gt;</code>
    </div>

    <h2 class="title">Ícones</h2>
    <p>Adicione no seu componente o atributo "icon" com o nome do seu ícone</p>

    <div class="highlight-grid">
      <round-button class="pink" icon="edit" type="submit">icon-edit</round-button>
      <round-button class="purple" icon="edit" type="submit">edit</round-button>
      <simple-button class="pink" icon="edit">icon-edit</simple-button>
      <simple-button class="purple" icon="edit">edit</simple-button>
      <code>
        &lt;round-button class="pink" icon="edit"&gt;icon-edit&lt;/round-button&gt;
      </code>
    </div>

    <h2 class="title">Ícone de seta</h2>
    <p>Adicione a classe "arrow"</p>
    <div class="highlight-grid">
      <p>
        <round-button class="purple arrow" type="submit">arrow</round-button>
        <simple-button class="purple arrow">arrow</simple-button>
      </p>
      <code>
        &lt;round-button class="purple arrow"&gt;arrow&lt;/round-button&gt;
      </code>
    </div>
    <br>
    <br>
    <br>
  </section>
</template>

<script>
  import RoundButton from '../components/RoundButton'
  import SimpleButton from '../components/SimpleButton'

  export default {
    components: { RoundButton, SimpleButton }
  }
</script>



// WEBPACK FOOTER //
// Buttons.vue?321b81cc